import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	getPortfolioReportingSummaryV2,
	type PortfolioReportingOverviewTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const getPortfolioReportingSummaryQuery = (
	filterPortfolioids?: number[],
	filterDatagroups?: PortfolioReportingOverviewTypeEnum[],
) => {
	return useQuery({
		queryKey: PortfolioKeys.reportingSummary(
			filterPortfolioids,
			filterDatagroups,
		),
		queryFn: processResponse(() =>
			getPortfolioReportingSummaryV2(filterPortfolioids, filterDatagroups),
		),
		enabled: filterPortfolioids !== undefined && filterPortfolioids.length > 0,
	});
};
